// Extracted session guard hook for reusability
import { useState, useEffect, useMemo } from "react"
import { onAuthStateChanged } from "firebase/auth"
import { auth } from "@/api/firebase"
import { loginAndSetSessionExpiry, SESSION_KEY } from "@/hooks/common/auth"

export function useSessionGuard() {
  const [initializing, setInitializing] = useState(true)
  const [isAuthed, setIsAuthed] = useState(false)

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      const now = Date.now()

      if (user) {
        // On sign-in or existing session, refresh TTL
        loginAndSetSessionExpiry()
        const stored = localStorage.getItem(SESSION_KEY)
        const nextExpiry = stored ? Number(stored) : 0
        setIsAuthed(nextExpiry > now)
      } else {
        setIsAuthed(false)
      }
      setInitializing(false)
    })
    return () => unsub()
  }, [])

  // Keep session fresh while user navigates if still valid
  useEffect(() => {
    if (!isAuthed) return
    const interval = window.setInterval(() => {
      const now = Date.now()
      const stored = localStorage.getItem(SESSION_KEY)
      const expiresAt = stored ? Number(stored) : 0
      if (expiresAt <= now) {
        setIsAuthed(false)
      }
    }, 60_000)
    return () => clearInterval(interval)
  }, [isAuthed])

  return useMemo(() => ({ initializing, isAuthed }), [initializing, isAuthed])
}